export const formatCurrency = (value, country) => {
  switch (country) {
    case "AU":
      return `A$${value}`;
    case "CA":
      return `C$${value}`;
    case "UK":
      return `£${value}`;
    case "US":
      return `$${value}`;
  }
};
